<template>
  <div class="group-roles-picker">
    <v-container fluid>
      <v-card class="mb-2">
        <v-banner v-if="groupRoles.length === 0">
          <v-icon slot="icon" color="grey" size="36">info</v-icon>
          <span>No role in group yet.</span>
        </v-banner>
        <v-list max-height="300px" style="overflow:auto" v-else>
          <v-subheader>Curent group roles</v-subheader>
          <v-list-item v-for="role in groupRoles" :key="role.uuid">
            <v-list-item-content>
              <v-list-item-title>{{role.name}}</v-list-item-title>
              <v-list-item-subtitle class="caption">{{role.description}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="removeRoleFromGroup(role.uuid, role.name)">
                <v-icon color="error">mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>
      <v-divider></v-divider>
      <v-data-iterator
        class="mt-2"
        :items="roles"
        hide-default-footer
        item-key="uuid"
        :custom-filter="filterRoles"
        :items-per-page.sync="itemsPerPage"
        :search="search"
      >
        <template v-slot:header>
          <v-toolbar dark color="blue darken-3" class="mb-1">
            <v-text-field
              v-model="search"
              clearable
              flat
              solo-inverted
              hide-details
              prepend-inner-icon="search"
              label="Search"
            ></v-text-field>
            <template v-if="$vuetify.breakpoint.mdAndUp"></template>
          </v-toolbar>
        </template>
        <template v-slot:default="props">
          <v-row>
            <v-col v-for="item in props.items" :key="item.uuid" cols="12" sm="6" md="3">
              <v-card>
                <v-card-text>
                  <v-card-title>{{item.name}}</v-card-title>
                  <v-card-subtitle>{{item.description}}</v-card-subtitle>
                </v-card-text>
                <v-card-actions>
                  <v-btn text color="success" @click="addRoleToGroup(item.uuid, item.name)">Add</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </template>
        <template v-slot:footer>
          <v-row class="ma-2" align="center" justify="center">
            <span class="grey--text">Items per page</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn dark text color="primary" class="ml-2" v-on="on">
                  {{ itemsPerPage }}
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(number, index) in itemsPerPageArray"
                  :key="index"
                  @click="updateItemsPerPage(number)"
                >
                  <v-list-item-title>{{ number }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <span class="mr-4 grey--text">Page {{ page }} of {{ numberOfPages }}</span>
            <v-btn fab dark color="blue darken-3" class="mr-1" @click="formerPage">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn fab dark color="blue darken-3" class="ml-1" @click="nextPage">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-row>
        </template>
      </v-data-iterator>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    group: { type: Object, required: true },
    roles: { type: Array, required: true },
    groupRoles: { type: Array, required: true }
  },
  data() {
    return {
      search: "",
      itemsPerPage: 10,
      page: 1,
      itemsPerPageArray: [10, 20, 50]
    };
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.roles.length / this.itemsPerPage);
    }
  },
  methods: {
    filterRoles(items, search) {
      search = search ? search : "";
      var filteredItems = items.filter(item =>
        item.name.toLowerCase().includes(search.toLowerCase())
      );
      return filteredItems;
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    addRoleToGroup(roleUuid, roleName) {
      this.$emit("addRoleToGroup", roleUuid, roleName);
    },
    removeRoleFromGroup(roleUuid, roleName) {
      this.$emit("removeRoleFromGroup", roleUuid, roleName);
    }
  }
};
</script>

<style>
</style>